export const fi = {
  page: {
    title: 'PreFor — Tunnemme metsäsi puut',
  },

  hero: {
    title: 'Tunnemme metsäsi puut',
    description: 'Metsäsi ja sen puut. Ne kasvavat ja niitä hoidetaan – mutta kuinka tarkasti tiedät mitä omistat? PreFor tietää, puun ja millimetrin tarkkuudella.',
    learnMore: 'Lue lisää',
    join: 'Haluatko liittyä meihin?',
    navigation: {
      whatWeDo: 'Mitä me teemme?',
      company: 'Yhtiö',
      contacts: 'Yhteystiedot',
    },
  },

  slogan: {
    text1: 'Optimoitu hakkuu.',
    text2: 'Maksimaalinen kasvu.',
  },

  timeline: {
    title: 'Aikajanamme',
    text2017: 'Silvere (myöhemmin PreFor) perustettiin vuonna 2017 keskittyen metsäympäristöjen korkean resoluution datan keräämiseen ja myyntiin. Tavoitteena oli tarjota tarkkaa paikkatietopohjaista aineistoa metsänhoidon, tutkimuksen ja teknologian tarpeisiin.',
    text2019: 'Onnistuneiden datankeruuhankkeiden myötä Silvere aloitti oman SLAM-algoritmin kehityksen pistepilviaineiston tarkkaa georeferointia ja rekisteröintiä varten. Kehitys mahdollistaa suurten, mobiilisti kerättyjen 3D-aineistojen tehokkaan yhdistämisen yhtenäiseksi ja laadukkaaksi kokonaisuudeksi.',
    text2022: 'Viiden vuoden tuotekehityksen jälkeen Silvere on saavuttanut valmiit ratkaisut datan keräämiseen massatuotantona sekä huipputason algoritmit datan käsittelyyn. Kehittämämme SLAM-algoritmi ja puulajien tunnistus ovat alan parasta tasoa.\n\nYrityksen nimi vaihtuu PreForiksi ja metskäkoneen autonmatisointin aloitetaan.',
    text2025: 'PreFor ottaa askeleen kohti uuden sukupolven harvennushakkuuta. Pitkän kehitystyön myötä syntyneet teknologiat mahdollistavat metsänhoidon, jossa toimenpiteet perustuvat korkean resoluution dataan ja koneohjattuun päätöksentekoon – tarkemmin ja tehokkaammin kuin koskaan ennen.',
  },

  company: {
    slogan: 'Guided by data. Driven by nature',
    title: 'Yhtiö',
    description: 'PreFor on vuonna 2017 perustettu yksityisomisteinen yhtiö. Toimitilamme sijaitsevat Helsingissä ja Espoossa. Meidän tiimimme koostuu muun muassa metsäasiantuntijoista, droonipiloteista, analyytikoista ja devaajista. Meidän yhteinen missio on tuoda lisäarvoa metsätalouden arvoketjuun ja mahdollistaa metsävarojen parempi hoito. Me uskomme vahvasti, että parempi ja tarkempi data on avaintekijä myös metsiemme hoitoon.',
  },

  contact: {
    title: 'Ota yhteyttä',
    description: 'Ota meihin yhteyttä mikäli olet kiinnostunut meidän palveluista, tai jos haluat liittyä meidän yhteiseen missioon.',
    email: 'Tavoitat meidän osoitteesta <1>info@prefor.fi</1>, tai ottamalla yhteyttä suoraan.',
    olli: {
      name: 'Olli Sirkiä',
      title: 'Chief Executive Officer (CEO)',
      description: 'Inventointi- ja erityisasiat',
      email: 'olli.sirkia@prefor.fi',
      phone: '+358 40 0202047',
    },
    aku: {
      name: 'Aku Moksi',
      title: 'Chief Operating Officer (COO)',
      description: 'Useimmat asiat',
      email: 'aku.moksi@prefor.fi',
      phone: '+358 40 4878056',
    },
  },

  concept: {
    title: 'Hakkuiden uusi aikakausi',
    block1: {
      title: 'Metsän skannaus',
      text: 'Preforin tarkkuusmetsänhoito hyödyntää tiheäpulssista lasermittausta. Mullistava menetelmämme perustuu kehittyneellä lennokilla tehtävään huipputarkkaan laserkeilaukseen. Järjestelmämme analysoi kerätyn datan automaattisesti ja nopeasti.',
    },
    block2: {
      title: 'Pilvipohjainen datan analyysi',
      text: 'Täsmämetsäinventaariomme tarjoaa tietoa yksittäisen puun tasolta alkaen, ja tieto voidaan agregoida mille tahansa halutulle tasolle (hila, kuvio). Täsmämetsätieto voidaan toimittaa asiakkaalle missä tahansa paikkatietoformaatissa, ja se on nähtävissä käyttöliittymämme kautta.',
    },
    block3: {
      title: 'Tekoälyn luoma metsänhoitosuunnitelma',
      text: 'Olemme luoneet aputyökalun parempaan metsänhoitoon. Me simuloimme metsien kasvua ja tunnistamme automaattisesti tarpeen metsänhoitotoimenpiteille ja hakkuille, silloin kun niiden tarve on.',
    },
    block4: {
      title: 'Puoliautomaattinen hakkuu',
      text: 'Metsätalouden arvoketjulla on merkittävä rooli maailmantaloudessa, ja tärkeä ilmastonmuutoksen torjunnassa ja biologisen monimuotoisuuden varmistamisessa. Silti metsätalouden arvoketjun monissa osissa käytetään hämmästyttävän vanhentuneita toimintatapoja. Meidän tarkkuusmetsätalouskonsepti tuo tähän muutoksen.',
    },
    block5: {
      title: 'Loppuraportti',
      text: 'Tehdyn työn jälkeen metsänomistajalle toimitetaan raportti, joka sisältää arvion metsän nykytilasta ja ennusteen sen tulevasta kasvusta. Raportti sisältää tietoa muun muassa puuston määrästä, lajijakaumasta ja terveydentilasta.',
    },
  },
}
